import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import "../assets/css/trackLoan.css";



const LOAN_STATUS_FLOW = [
  {
    key: "submitted",
    label: "Application Submitted",
    description: "Your loan request has been received",
  },
  {
    key: "reviewing",
    label: "Under Review",
    description: "Our team is reviewing your application",
  },
  {
    key: "approved",
    label: "Approved",
    description: "Your loan has been approved",
  },
  {
    key: "disbursed",
    label: "Disbursed",
    description: "Funds have been sent to your account",
  },
];

const TERMINAL_STATUSES = {
  rejected: {
    label: "Rejected",
    description: "Unfortunately, your loan was not approved",
  },
  cancelled: {
    label: "Cancelled",
    description: "This loan application was cancelled",
  },
};
const resolveLoanProgress = (status) => {
  const index = LOAN_STATUS_FLOW.findIndex(
    (s) => s.key === status
  );

  return {
    isTerminal: Boolean(TERMINAL_STATUSES[status]),
    currentIndex: index === -1 ? 0 : index,
    terminal: TERMINAL_STATUSES[status] || null,
  };
};

export default function TrackLoan() {

    const formatStatus = (s) =>
  s.charAt(0).toUpperCase() + s.slice(1);

  const { trackingId: trackingFromUrl } = useParams();

  const [trackingId, setTrackingId] = useState(trackingFromUrl || "");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [loan, setLoan] = useState(null);
  const [showModal, setShowModal] = useState(false);

  

  const fetchLoanStatus = async (e, idOverride = null) => {
  e?.preventDefault();

  const idToUse = idOverride || trackingId;
  if (!idToUse) return;

  setLoading(true);
  setError("");
  setLoan(null);
  setShowModal(true);

  try {
    const res = await fetch(
      `http://localhost/GMT_TECHNOLOGIES_LIMITED_CLEAN/gmt-api/track_loan.php?tracking_id=${idToUse}`
    );
    const data = await res.json();

    if (!data.success) {
      setError(data.message || "Tracking ID not found");
      return;
    }

    setLoan(data.data);
  } catch {
    setError("Unable to fetch loan status. Please try again.");
  } finally {
    setLoading(false);
  }
};

useEffect(() => {
  if (trackingFromUrl) {
    setTrackingId(trackingFromUrl);
    fetchLoanStatus(null, trackingFromUrl);
  }
}, [trackingFromUrl]);


  const closeModal = () => {
    setShowModal(false);
    setLoan(null);
    setError("");
  };

  return (
    <div className="track-loan-page">
      <div className="track-loan-card">
        <h2>Track Your Loan</h2>
        <p className="sub-text">
          Enter your tracking ID to view the status of your loan application.
        </p>

        {/* SEARCH */}
        <form onSubmit={fetchLoanStatus} className="track-form">
          <input
            className="form-control"
            placeholder="Enter Tracking ID"
            value={trackingId}
            onChange={(e) => setTrackingId(e.target.value)}
          />
          <button className="btn btn-primary" disabled={loading}>
            {loading ? "Checking..." : "Track Loan"}
          </button>
        </form>

        {/* PRE-SEARCH INFO */}
        {!showModal && (
          <div className="track-info">
            <div className="info-item">
              <h4>🔍 Real-time Tracking</h4>
              <p>Monitor your loan application status instantly.</p>
            </div>

            <div className="info-item">
              <h4>👨‍💼 Dedicated Officer</h4>
              <p>Your application is handled by a specific account officer.</p>
            </div>

            <div className="info-item">
              <h4>🔒 Secure Process</h4>
              <p>Your data is protected using industry-standard security.</p>
            </div>
          </div>
        )}
      </div>

      {/* ================= MODAL ================= */}
     {showModal && (
  <div className="modal-overlay" onClick={closeModal}>
   <div className="modal-card" onClick={(e) => e.stopPropagation()}>
  <button className="modal-close" onClick={closeModal}>×</button>

  {/* HEADER */}
  <div className="modal-header">
    <div>
      <h3>Loan Tracking Result</h3>
      <p className="modal-subtext">
        Review the status of your loan application below
      </p>
    </div>
  </div>

  {/* BODY */}
  <div className="modal-body">
    {loading && (
      <div className="loan-skeleton">
        <div className="skeleton-line w-40" />
        <div className="skeleton-line w-60" />
        <div className="skeleton-line w-50" />
      </div>
    )}

    {!loading && error && (
      <div className="error-state">
        <div className="error-head">
          <span className="error-icon">⚠️</span>
          <h4>We couldn’t find your loan</h4>
        </div>

        <p className="error-text">
          Sorry, we’re unable to track your loan at the moment.
          This could be due to one of the following reasons:
        </p>

        <ul className="error-list">
          <li>The tracking ID entered is incorrect</li>
          <li>You do not have a pending loan application</li>
          <li>Your loan is still being processed</li>
        </ul>
      </div>
    )}

   {!loading && loan && (() => {
  const progress = resolveLoanProgress(loan.status);

  return (
    <>
      {/* ================= SUMMARY ================= */}
      <div className="card highlight-card">
        <div className="row">
          <span>Tracking ID</span>
          <strong>{loan.tracking_id}</strong>
        </div>

        <div className="row">
          <span>Loan Product</span>
          <strong>{loan.loan_product}</strong>
        </div>

        <div className="row">
          <span>Loan Amount</span>
        <strong>
  ₦{Number(loan.loan_amount).toLocaleString()}
</strong>

        </div>

        <div className="row">
          <span>Status</span>
       <span className={`status-badge status-${loan.status}`}>
  {formatStatus(loan.status)}
</span>

        </div>
      </div>

      {/* ================= OFFICER ================= */}
      <div className="card officer-box">
        <h4>Account Officer</h4>

        <div className="row">
          <span>Name</span>
          <strong>{loan.rm_name}</strong>
        </div>

        <div className="row">
          <span>Email</span>
          <strong>{loan.rm_email}</strong>
        </div>
      </div>

      {/* ================= TIMELINE ================= */}
      <div className="card timeline-card">
        <h4>Application Progress</h4>

        {progress.isTerminal ? (
          <div className="terminal-state">
            <h3>{progress.terminal.label}</h3>
            <p>{progress.terminal.description}</p>
          </div>
        ) : (
          <ul className="timeline">
            {LOAN_STATUS_FLOW.map((step, idx) => {
              const isCompleted = idx < progress.currentIndex;
              const isActive = idx === progress.currentIndex;

              return (
                <li
                  key={step.key}
                  className={`timeline-step
                    ${isCompleted ? "completed" : ""}
                    ${isActive ? "active" : ""}
                  `}
                >
                  <div className="dot" />
                  <div className="content">
                    <h5>{step.label}</h5>
                    <p>{step.description}</p>
                  </div>
                </li>
              );
            })}
          </ul>
        )}
      </div>
    </>
  );
})()}

  </div>

  {/* FOOTER */}
  <div className="modal-footer">
    {!loading && error && (
      <>
        <button className="btn-secondary" onClick={closeModal}>
          Try Again
        </button>
        <a
          href="mailto:info@gmttechnologies.com"
          className="btn-outline"
        >
          Contact Support
        </a>
      </>
    )}

    {!loading && loan && (
      <p className="support-note">
        Need help? <strong>info@gmttechnologies.com</strong>
      </p>
    )}
  </div>
</div>





  </div>
)}





    </div>
  );
}
